/* eslint-disable jsx-a11y/anchor-is-valid */
/** @jsxImportSource @emotion/react */
import Box from '@mui/material/Box';
import { css, useTheme } from '@emotion/react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Lock from '@mui/icons-material/Lock';
import { useSelector } from 'react-redux';
import makePrivacyPolicyStyling from './usePrivacyPolicyStyles';

const PrivacyPolicyLink = () => {
  const theme = useTheme();
  const styles = makePrivacyPolicyStyling(theme);
  const { privacyPolicy } = useSelector((store) => store.formConfig);
  const { currentPage } = useSelector((store) => store.navigation);
  const { pagesWithLoaderComponent } = useSelector((store) => store.paging);
  const components = useSelector((store) => store.components);

  const isLoaderPage = pagesWithLoaderComponent.includes(currentPage);

  const newsletterComponentsOnPage = Object.values(components).filter(
    (component) => {
      if (
        component.component.type === 'newsletter-signup' &&
        component.component.page === currentPage
      ) {
        return true;
      }
      return false;
    }
  );

  if (
    !privacyPolicy.link ||
    isLoaderPage ||
    newsletterComponentsOnPage.length > 0
  ) {
    return null;
  }

  return (
    <Box
      css={css({ marginBottom: theme.mvf.spacing.medium })}
      justifyContent="center"
    >
      <Typography css={styles.text}>
        <Link
          css={styles.link}
          onClick={(event) => {
            event.preventDefault();
            window.open(privacyPolicy.link, '_blank');
          }}
          data-testid="privacyPolicyLink"
          underline="hover"
        >
          <Lock css={styles.lock} />
          {privacyPolicy.text || 'Privacy Policy'}
        </Link>
      </Typography>
    </Box>
  );
};

export default PrivacyPolicyLink;
